/**
 * 仅开发：通过 URL 查询参数预览「版本更新」弹窗与 TopBar 样式，不发起真实 version.json 比对。
 *
 * - `?jointoPreviewAppUpdate=1`：模拟有新版本（含「稍后更新」+「立即更新」）。
 * - 再加 `&jointoPreviewAppUpdateForce=1`：模拟强制更新（仅「立即更新」）。
 * - 再加 `&jointoPreviewAppUpdateCleanup=1`：模拟「已刷新到新代码但缓存清理未完成」（隐含强制）。
 * - 再加 `&jointoPreviewAppUpdateChangelog=1`：模拟带有更新日志的情况。
 */
export function readAppUpdateUiPreviewParams(): {
  active: boolean;
  forceHardRefresh: boolean;
  cleanupOnly: boolean;
  withChangelog: boolean;
} {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return { active: false, forceHardRefresh: false, cleanupOnly: false, withChangelog: false };
  }
  const q = new URLSearchParams(window.location.search);
  const cleanupOnly = q.get('jointoPreviewAppUpdateCleanup') === '1';
  return {
    active: q.get('jointoPreviewAppUpdate') === '1',
    // 清理待完成只会出现在强制更新场景，预览时一并置为强制，否则会落到 Toast 分支
    forceHardRefresh: cleanupOnly || q.get('jointoPreviewAppUpdateForce') === '1',
    cleanupOnly,
    withChangelog: q.get('jointoPreviewAppUpdateChangelog') === '1',
  };
}
